export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(" ");
  }
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
}

export function formatDate(iso, opts = {}) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: opts.withYear !== false ? "numeric" : undefined,
    });
  } catch {
    return iso;
  }
}

export function daysBetween(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  const now = new Date();
  const ms = d - now;
  return Math.ceil(ms / 86400000);
}

export function relativeDue(iso) {
  const d = daysBetween(iso);
  if (d === null) return "—";
  if (d < 0) return `${Math.abs(d)}d overdue`;
  if (d === 0) return "Due today";
  if (d === 1) return "Due tomorrow";
  if (d < 7) return `Due in ${d}d`;
  if (d < 30) return `Due in ${Math.round(d / 7)}w`;
  return `Due in ${Math.round(d / 30)}mo`;
}

export function currency(n) {
  if (n == null || n === "") return "—";
  return `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
